import { LayoutDataType } from '../../types';

export const stepDataByInteractionIdMap: Record<
  NonNullable<LayoutDataType['interaction']>,
  {
    title: string;
    subtitle: string;
  }
> = {
  deep_connection: {
    title: 'Grow closer together 🔥',
    subtitle:
      'Deepen your relationship with a character and open new features at each level',
  },
  friendship: {
    title: 'Get to know each other 🔥',
    subtitle:
      'Explore true friendship with our characters and unlock new rewards at each level',
  },
  casual_chatting: {
    title: 'Discuss your interests 🔥',
    subtitle:
      'Have fun without pressure with our characters and gain rewards at each level',
  },
  one_night_stand: {
    title: 'Explore each other 🔥',
    subtitle:
      'Share your secret desires with a character and explore new features at each level',
  },
};
